import { render, staticRenderFns } from "./success-checkmark-component-2.vue?vue&type=template&id=505ff63e&lang=html&"
import script from "./success-checkmark-component-2.vue?vue&type=script&lang=js&"
export * from "./success-checkmark-component-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports